// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"612":"a2b9aedba29cc1afa916","924":"f8477ccab0c05f9fed0e"}[chunkId] + ".js";
};